/*
 * Copyright © 2025. Legalbird eine Marke der Legalbird GmbH
 */

import React, { ReactElement } from "react";
import powerOfAttorneyNextStepsStyle from "./powerOfAttorneyNextStepsStyle";
import Grid from "@mui/material/Grid";
import Paper from "@mui/material/Paper";
import FrankRiedelImage from "../../../../assets/img/jobs/frankriedel.jpg";

type PowerOfAttorneyNextStepsProps = {
  bulletPoints: Array<string | ReactElement>;
};

export default function PowerOfAttorneyNextSteps({ bulletPoints }: PowerOfAttorneyNextStepsProps) {
  return (
    <Grid container spacing={2}>
      <Grid
        sx={{ paddingTop: "1rem" }}
        size={{
          sm: 2,
          xs: 12
        }}>
        <Paper elevation={4} sx={powerOfAttorneyNextStepsStyle.imageCircleContainer}>
          <img src={FrankRiedelImage} alt={"Rechtsanwalt Frank Riedel"} />
        </Paper>
      </Grid>
      <Grid
        sx={powerOfAttorneyNextStepsStyle.text}
        size={{
          sm: 10,
          xs: 12
        }}>
        <ol>
          {bulletPoints.map((step, index) => (
            <li key={index} {...(typeof step === "string" ? { dangerouslySetInnerHTML: { __html: step } } : { children: step })} />
          ))}
        </ol>
      </Grid>
    </Grid>
  );
}
